import * as React from 'react'
import type {OmitStrict} from 'type-zoo'
import type {
  TGlobalErrorDisplay,
  TNoFormFields,
  TPeripheralConstraintData,
} from '~/components/ProvideForm/base'
import ProvideForm from '~/components/ProvideForm/normal'
import type {TConstraint} from '~/components/ProvideForm/utils'
import type {IDSButtonProps} from '~/design-system/Button'
import DSButton from '~/design-system/Button'

export interface ISingleButtonFormProps<PromiseResultType = any> extends OmitStrict<
  IDSButtonProps,
  'onClick' | 'className'
> {
  globalErrorDisplay?: TGlobalErrorDisplay
  onSubmit: () => Promise<PromiseResultType>
  submitSuccess?: (result: PromiseResultType) => void
  submitFailure?: (error: unknown) => void
  classNames?: {
    button?: string
    wrapper?: string
  }
  peripheralConstraints?: TConstraint<TPeripheralConstraintData<TNoFormFields>>[]
}

export class SingleButtonForm<PromiseResultType = any> extends React.Component<
  ISingleButtonFormProps<PromiseResultType>
> {
  render() {
    const {
      appearDisabled,
      disabled,
      globalErrorDisplay,
      onSubmit,
      peripheralConstraints,
      submitSuccess,
      submitFailure,
      classNames,
      ...buttonProps
    } = this.props

    return (
      <ProvideForm<TNoFormFields, PromiseResultType>
        globalErrorDisplay={globalErrorDisplay}
        onSubmit={onSubmit}
        submitSuccess={(_, r) => submitSuccess?.(r)}
        submitFailure={(_, e) => submitFailure?.(e)}
        getPreviouslySubmittedValuesFromInitialValues
        peripheralConstraints={peripheralConstraints}
        wrapperClassName={classNames?.wrapper}
        toFormFields={(generateFormFieldProps, formProps) => {
          const isButtonDisabled =
            disabled || formProps.isFormSubmitting || formProps.anyErrors

          return (
            <DSButton
              loading={formProps.isFormSubmitting}
              disabled={isButtonDisabled}
              appearDisabled={appearDisabled || isButtonDisabled}
              onClick={() => formProps.onSubmit()}
              className={classNames?.button}
              {...buttonProps}
            />
          )
        }}
      />
    )
  }
}
